import { render, staticRenderFns } from "./TributeAdmin.vue?vue&type=template&id=3e97a2f3"
import script from "./TributeAdmin.vue?vue&type=script&lang=js"
export * from "./TributeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports